/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PresetIcon = ({ width = 24, height = 24, hidden = false, title = 'Preset' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34 14a12 12 0 0 0-23.483-3.483 12.038 12.038 0 0 1 2.3-.457A10 10 0 1 1 25.94 23.185a12.038 12.038 0 0 1-.457 2.3A12 12 0 0 0 34 14Z"
    />
    <path
      d="M14 12h2v2h-2zM12 14h2v2h-2zM14 16h2v2h-2zM12 18h2v2h-2zM14 20h2v2h-2zM16 22h2v2h-2zM16 18h2v2h-2zM16 14h2v2h-2zM18 16h2v2h-2zM18 20h2v2h-2z"
    />
    <path
      d="M24 25.817V24h-2v2a11.986 11.986 0 0 1-2-.18V24h-2v1.3a11.939 11.939 0 0 1-2-.922V24h-.628A11.886 11.886 0 0 1 14 22.926V22h-.926A12.173 12.173 0 0 1 12 20.628V20h-.381a11.856 11.856 0 0 1-.921-2H12v-2h-1.82a11.986 11.986 0 0 1-.18-2h2v-2h-1.817a12.068 12.068 0 0 1 .334-1.482 12 12 0 1 0 14.966 14.964 12.128 12.128 0 0 1-1.483.335Z"
    />
    <path
      d="M20 22h2v2h-2zM22 20h2v2h-2zM20 18h2v2h-2zM22 16h2v2h-2zM20 14h2v2h-2zM18 12h2v2h-2zM26 22h-2v2h1.817A11.881 11.881 0 0 0 26 22ZM25.3 18H24v2h1.82a11.908 11.908 0 0 0-.52-2ZM24 15.372V16h.381a11.785 11.785 0 0 0-.381-.628ZM12 12h2v-2a11.881 11.881 0 0 0-2 .183ZM16 10.18V12h2v-1.3a11.908 11.908 0 0 0-2-.52ZM20 11.619V12h.628a11.785 11.785 0 0 0-.628-.381ZM22 13.074V14h.926a11.9 11.9 0 0 0-.926-.926Z"
    />
  </svg>`;
};
